import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import Form from '../Crud/Form';

export interface TransactionNatureFormFields {
  name: string;
  description?: string;
}

interface TransactionNatureFormProps {
  isLoading: boolean;
  title: string;
  formFields: TransactionNatureFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function TransactionNatureForm({
  isLoading,
  title,
  formFields,
  formErrors,
  onSubmit,
}: TransactionNatureFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<TransactionNatureFormFields>();

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <Form isLoading={isLoading} title={title} onSubmitCallback={() => {}}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Nome
          </label>
          <input
            {...register('name', { required: true })}
            className='form-control'
            placeholder='Nome'
            type='text'
            required
          />
          {errors.name && (
            <div className='form-text text-danger'>{errors.name.message}</div>
          )}
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Descrição
          </label>
          <textarea
            {...register('description')}
            className='form-control'
            placeholder='Descrição'
          />
          {errors.description && (
            <div className='form-text text-danger'>
              {errors.description.message}
            </div>
          )}
        </div>
        <div className='d-flex justify-content-end gap-2'>
          <Link to='/transaction-natures' className='btn btn-secondary'>
            Cancelar
          </Link>
          <button type='submit' className='btn btn-primary'>
            Salvar
          </button>
        </div>
      </form>
    </Form>
  );
}
